/**
 * inits accordion
 */
export function initAccordion() {
    const accordionOuterWrap = $('.accordion');
    if (accordionOuterWrap.length) {
        accordionOuterWrap.each(function () {

            let active = $(this).data('firstactive');

            $(this).accordion({
                collapsible: true,
                heightStyle: 'content',
                active: active === 1 ? 0 : false,
                activate: function (event, ui) {
                    if (!$.isEmptyObject(ui.newHeader.offset())) {

                        let headerOuterWrap = $('.header-outer-wrap')[0];
                        if (headerOuterWrap) {

                            let offset = ui.newHeader.offset().top - headerOuterWrap.offsetTop - headerOuterWrap.offsetHeight - 20;

                            $('html:not(:animated), body:not(:animated)').animate({scrollTop: offset}, 'slow');
                        }
                    }
                }
            });
            $(this).find('.ui-accordion-header').click(function () {
                $(this).next()
                    .find('.swiper-container')[0]
                    ?.swiper
                    ?.update();
            });
        });
    }
}